import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Page } from 'components/layouts';
import Spinner from 'components/spinner';

import style from './style.module.css';

const FullPageLoading = ({ delay, header, ...rest }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);

  return (
    <Page className={style.page} header={header} overlay={false} {...rest}>
      {show ? (
        <div className={style.wrapper}>
          <Spinner className={style.spinner} />
        </div>
      ) : null}
    </Page>
  );
};

FullPageLoading.propTypes = {
  delay: PropTypes.number,
  header: PropTypes.bool,
};

FullPageLoading.defaultProps = {
  delay: 0,
  header: true,
};

export default FullPageLoading;
